import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {NavLink, useParams, useLocation} from 'react-router-dom';
import {DashboardLayout} from '../../components';
import {ROUTES} from './LayoutConstants';
import ProfileAndCommentSection from './ProfileSection';
import {useQuery} from 'react-query';
import {fetchCustomerDetails} from '../../requests/queries/customer360';
import Breadcrumbs from 'components/BreadCrumbs';
import {Constants} from 'helpers';

function Layout({children, pageTitle = '', action, nestedItems = []}) {
  const {slug} = useParams();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const CUSTOMER_360_BASE_PATH = Constants.PAGES_URL.CUSTOMER_360;

  useEffect(() => {
    const currentId = sessionStorage.getItem('current-slug');
    if (currentId !== slug) {
      setLoading(true);
      const timer = setTimeout(() => {
        setLoading(false);
        sessionStorage.setItem('current-slug', slug);
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [slug]);

  const {data: userDetails, isLoading: userDetailsLoading} = useQuery(
    ['user-details', slug],
    () => fetchCustomerDetails(slug),
    {retry: false},
  );

  const breadcrumbItems = [
    ...nestedItems,
    ...(pageTitle ? [{label: pageTitle, path: location.pathname}] : []),
  ];

  return (
    <DashboardLayout
      breadCrumbs={
        <p className="text-tiny font-normal text-deepBlue">{pageTitle}</p>
      }
    >
      <div className="flex items-center min-h-[52px] py-2 flex-wrap gap-3 justify-between mx-[-32px] px-8 border border-transparent border-b-[#E4E4E6]">
        <Breadcrumbs
          mainText="Customer 360"
          mainTextPath={CUSTOMER_360_BASE_PATH}
          items={breadcrumbItems}
        />
        <div className="flex">{action ?? null}</div>
      </div>

      <div className="mt-4">
        <div className="rounded-md bg-[#F7F7F7] w-fit p-1 flex items-center gap-2 overflow-x-auto">
          {ROUTES.map((route, index) => (
            <NavLink
              key={index}
              end={false}
              to={route.path.replace(':slug', slug)}
              className={({isActive}) =>
                `px-7 py-1.5 min-h-8 text-sm flex items-center justify-center rounded-lg shadow-[0px_4px_32px_-4px,rgba(199,196,196,0.18)] ${
                  isActive
                    ? 'text-black bg-white shadow-tabs'
                    : 'text-grey-500 bg-transparent'
                }`
              }
            >
              {route.name}
            </NavLink>
          ))}
        </div>
      </div>

      <div className="mt-4 flex w-full">
        <div className="w-[65%]">{children}</div>
        <ProfileAndCommentSection
          userDetails={userDetails}
          userDetailsLoading={userDetailsLoading || loading}
        />
      </div>
    </DashboardLayout>
  );
}

export default connect(state => state, null)(Layout);
